import { QarepaEnumInformation } from '@qarepa/common';

export enum InvitationStatusEnum {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING',
}

export type InvitationStatusType =
  | InvitationStatusEnum.ACCEPTED
  | InvitationStatusEnum.REJECTED
  | InvitationStatusEnum.CANCELLED
  | InvitationStatusEnum.PENDING;

export const InvitationStatusArray = [
  InvitationStatusEnum.ACCEPTED,
  InvitationStatusEnum.REJECTED,
  InvitationStatusEnum.CANCELLED,
  InvitationStatusEnum.PENDING,
];

export const InvitationStatusInfo: QarepaEnumInformation<InvitationStatusEnum> =
  {
    [InvitationStatusEnum.ACCEPTED]: {
      name: $localize`Aceptada`,
    },
    [InvitationStatusEnum.REJECTED]: {
      name: $localize`Rechazada`,
    },
    [InvitationStatusEnum.CANCELLED]: {
      name: $localize`Cancelada`,
    },
    [InvitationStatusEnum.PENDING]: {
      name: $localize`Pendiente`,
    },
  };
